import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 2063  -  高级UI跳转剧情
 */

export default class EventJumpStoryUI extends EventBase {
    /**
     * 跳转剧情的构造函数
     */
    constructor() {
        super()
        this.Parameter = ['1', '1', '']
    }

    // #region 事件内主要属性参数
    /**
     * 剧情ID
     */
    get MapId() {
        return parseInt(this.Parameter?.[0] ?? '')
    }
    set MapId(value) {
        this.Parameter![0] = value.toString()
    }

    /**
     * 是否淡出
     */
    get IsFadeOut() {
        return this.Parameter?.[1] == '1'
    }
    set IsFadeOut(value) {
        this.Parameter![1] = value ? '1' : '0'
    }

    /**
     * 描述信息
     */
    get Description() {
        return this.Parameter?.[2] || ''
    }
    set Description(value) {
        this.Parameter && (this.Parameter[2] = value.toString())
    }

    // #endregion

    /**
     * 事件ID
     */
    Code = EventID.JumpStoryUI

    /**
     * 获得该事件在事件列表的描述信息
     */
    /// <returns>事件描述信息</returns>
}
